import Vue from 'vue';
import VueCollapse from 'vue2-collapse';

Vue.use(VueCollapse);